import SideBarMain from "../../components/cm/SideBarMain";
import AppWrapper from "../../components/cm/AppWrapper";
import { MainNavBarEnum } from "../../components/cm/SideBarMain/MainNavBarEnum";
import MCCDashboardWrapper from "../../components/modules/FollowUps/modules/Wrapper/MCCDashboardWrapper";
import KPIDashboard from "../../components/modules/FollowUps/dashboard-metrics/KPIDashboard";
import FollowUpModalProvider from "../../components/modules/FollowUps/dashboard-swimlanes/context/FollowUpModalContext";
import FollowUpSwimlanes from "../../components/modules/FollowUps/dashboard-swimlanes/followup-swimlanes";

export default () => {
  return (
    <AppWrapper.WithSidebar
      sidebar={<SideBarMain activeRoute={MainNavBarEnum.DASHBOARD} />}
    >
      <MCCDashboardWrapper>
        <KPIDashboard />
        <FollowUpModalProvider>
          <FollowUpSwimlanes />
        </FollowUpModalProvider>
      </MCCDashboardWrapper>
    </AppWrapper.WithSidebar>
  );
};
